import * as React from 'react';
import { connect } from 'react-redux';
import People from '../People/People';
import SaveHOC from '../HOC/SaveHOC';
import { setFormDirty } from '@company/features/action.company';
import { ISpecificPeopleProps } from '../People/IPeople';
import { TReducers } from '@features/reducers';

const isEqual = require('lodash.isequal');

export class Members extends React.Component<ISpecificPeopleProps> {

  state = {
    data: this.props.people,
  };

  shouldComponentUpdate(nextProps: ISpecificPeopleProps, nextState: any) {
    if (this.props.formDirty !== nextProps.formDirty && isEqual(this.state.data, nextState.data)) return false;

    return true;
  }

  UNSAFE_componentWillReceiveProps(nextProps: ISpecificPeopleProps) {
    if (!isEqual(this.props.people, nextProps.people)) {
      this.setState({
        data: nextProps.people,
      });
    }
  }

  updateStateFromChild = (data: any) => {
    const prevState = this.state.data;
    this.setState({ data }, () => {
      if (!isEqual(prevState, this.state.data) && this.props.editMode && !this.props.formDirty) {
        this.props.dispatch(setFormDirty(true));
      }
    });
  }

  render() {
    return (
      <People
        editMode={this.props.editMode}
        companyID={this.props.companyID}
        title="Team Member"
        updateStateFromChild={this.updateStateFromChild}
        people={this.state.data}
        dispatch={this.props.dispatch}
      />
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    people: store.companyReducer.companyMembers,
    formDirty: store.companyReducer.formDirty,
  };
};

export default connect(mapStateToProps)(SaveHOC(Members, 'companyMembers'));
